export const PASSWORD_MIN_LENGTH = 8

export const PASSWORD_REQUIREMENTS = [
  `At least ${PASSWORD_MIN_LENGTH} characters`,
  'At least one uppercase letter',
  'At least one lowercase letter',
  'At least one number',
  'At least one special character',
]
